import { render, staticRenderFns } from "./AndesHeader.vue?vue&type=template&id=e8216b2e&"
import script from "./AndesHeader.vue?vue&type=script&lang=js&"
export * from "./AndesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports